<template>
  <div class="col-sm-12 col-md">
    <abstract-profile-text-input
      id="input-identification-number"
      v-model="model"
      :error="errors"
      :label="computedLabel"
      :placeholder="computedPlaceholder"
      @change="inputChange"
      @input="onInput"
      :rules="required ? 'required' : ''"
    />
  </div>
</template>

<script>
import AbstractProfileTextInput from "../core/AbstractProfileTextInput";
import BaseInputMixin from "../../../../mixins/profileInputMixin";

export default {
  name: "IdentificationNumber",
  components: {AbstractProfileTextInput},
  mixins: [BaseInputMixin('identification.personal_identification_number')],

  data() {
    return {
      defaultLabel: this.$t("Identification Number")
    }
  },
}
</script>

<style scoped>

</style>
